import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Login from "./Components/Login/Login";
import Registration from "./Components/Registration/Registration";
import Home from "./Components/Home/Home";
import HelpDesk from "./Components/HelpDesk/HelpDesk";
import Notification from "./Components/HelpDesk/Notification";
import WelcomePage from "./Components/WelcomePage/WelcomePage";
import Profile from "./Components/Profile/Profile";
import DashboardSelect from "./Components/DashboardSelect/DashboardSelect";
import DashboardBOT from "./Components/Dashboard/DashboardBOT";
import DashboardFIX from "./Components/Dashboard/DashboardFIX";

import ActivateBOT from "./Components/Activation/ActivateBOT";
import ActivateFOREX from "./Components/Activation/ActivateFOREX";
import Activate_HistoryBOT from "./Components/Activate History/Activate_HistoryBOT";

import Activate_HistoryFOREX from "./Components/Activate History/Activate_HistoryFOREX";
import Forgotpassword from "./Components/Login/Forgotpassword";
import ROIIncomefix from "./Components/IncomeReportFix/ROIIncomefix";
import DirectIncomeFixx from "./Components/IncomeReportFix/DirectIncomeFixx";
import ROIlevelIncomefix from "./Components/IncomeReportFix/ROIlevelIncomefix";
import ROIIncomeBot from "./Components/IncomeReportBot/ROIIncomeBot";
import DirectTeamBOT from "./Components/TeamReport/DirectTeamBOT";
import DownLineTeamBOT from "./Components/TeamReport/DownLineTeamBOT";
import LevelDetailsBOT from "./Components/TeamReport/LevelDetailsBOT";
import DirectTeamFIX from "./Components/TeamReport/DirectTeamFIX";
import DownLineTeamFIX from "./Components/TeamReport/DownLineTeamFIX";
import LevelDetailsFIX from "./Components/TeamReport/LevelDetailsFIX";
import DirectIncomeBot from "./Components/IncomeReportBot/DirectIncomeBot";
import ROIlevelIncomeBot from "./Components/IncomeReportBot/ROIlevelIncomeBot";
import MatchingIncomeBot from "./Components/IncomeReportBot/MatchingIncomeBot";
import MatchingLevelIncomeBot from "./Components/IncomeReportBot/MatchingLevelIncomeBot";
import RewardInomeBot from "./Components/IncomeReportBot/RewardInomeBot";
import ClubIncomeBot from "./Components/IncomeReportBot/ClubIncomeBot";
import ClubRoyaltyIncomeBot from "./Components/IncomeReportBot/ClubRoyaltyIncomeBot";
import FranchiseInomeBot from "./Components/IncomeReportBot/FranchiseInomeBot";
import WithdrawalBOT from "./Components/Withdrawal/WithdrawalBOT";
import WithdrawalFIX from "./Components/Withdrawal/WithdrawalFIX";
import WithdrawalHistoryBOT from "./Components/Withdrawal/WithdrawalHistoryBOT";
import WithdrawalHistoryFIX from "./Components/Withdrawal/WithdrawalHistoryFIX";
import CashbackIncomeBot from "./Components/IncomeReportBot/CashbackIncomeBot";
import CashBackIncomeFix from "./Components/IncomeReportFix/CashBackIncomeFix";
import Deposit from "./Components/Deposit/Deposite";
import DepositHistory from "./Components/Deposit/DepositHistory";
import AdminLogin from "./Components/Login/AdminLogin";
import HelpDeskBoat from "./Components/HelpDesk/HelpDeskBoat";
import MatchingTreeBOT from "./Components/Tree_View/MatchingTreeBOT";
import MatchingTreeFIX from "./Components/Tree_View/MatchingTreeFIX";
import MatchingIncomeFIX from "./Components/IncomeReportFix/MatchingIncomeFIX";
import RewardInomeFIX from "./Components/IncomeReportFix/RewardInomeFIX";
import TradingIncomeFIX from "./Components/IncomeReportFix/TradingIncomeFIX";
import TradingLevelIncomeFIX from "./Components/IncomeReportFix/TradingLevelIncomeFIX";
import DirectIncomeFixTrading from "./Components/IncomeReportFix/DirectIncomeFixTrading";
import Activate_HistorySECURE from "./Components/Activate History/Activate_HistorySECURE";
import ActivateSECURE from "./Components/Activation/ActivateSECURE";
import ActivateALGOTRADING from "./Components/Activation/ActivateALGOTRADING";
import Activate_HistoryALGOTRADING from "./Components/Activate History/Activate_HistoryALGOTRADING";
import ActivateADVTRADING from "./Components/Activation/ActivateADVTRADING";
import Activate_HistoryADVTRADING from "./Components/Activate History/Activate_HistoryADVTRADING";
import DownlineActHistoryFIX from "./Components/Activate History/DownlineActHistoryFIX";
import DownlineActHistoryBOT from "./Components/Activate History/DownlineActHistoryBOT";
import ActivateALGOTRADINGContract from "./Components/Activation/ActivateALGOTRADINGContract";
import ActivateADVTRADINGContract from "./Components/Activation/ActivateADVTRADINGContract";
import ActivateSECUREContract from "./Components/Activation/ActivateSECUREContract";
import SilveGoldincomeFraFix from "./Components/IncomeReportFix/SilveGoldincomeFraFix";
import Statedistfranchiseebusiness from "./Components/IncomeReportBot/Statedistfranchiseebusiness";
import Distfranchiseebusiness from "./Components/IncomeReportBot/Distfranchiseebusiness";

function App() {
  return (
    <>
      <div className="App">
        <Toaster />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/Forgotpassword" element={<Forgotpassword />} />
          <Route exact path="/register" element={<Registration />} />
          <Route path="/AdminLogin" element={<AdminLogin />} />
          <Route path="/WelcomePage" element={<WelcomePage />} />

          <Route exact path="/Profile" element={<Profile />} />
          <Route exact path="/Deposit" element={<Deposit />} />
          <Route exact path="/DepositHistory" element={<DepositHistory />} />

          <Route exact path="/ActivateSECURE" element={<ActivateSECURE />} />
          <Route exact path="/ActivateALGOTRADING" element={<ActivateALGOTRADING />} />
          <Route exact path="/ActivateADVTRADING" element={<ActivateADVTRADING />} />
          <Route exact path="/DownlineActHistoryFIX" element={<DownlineActHistoryFIX />} />
          <Route exact path="/ActivateBOT" element={<ActivateBOT />} />
          <Route exact path="/ActivateFOREX" element={<ActivateFOREX />} />
          <Route exact path="/DownlineActHistoryBOT" element={<DownlineActHistoryBOT />} />
          <Route
            exact
            path="/Activate_HistoryBOT"
            element={<Activate_HistoryBOT />}
          />
          <Route
            exact
            path="/Activate_HistorySECURE"
            element={<Activate_HistorySECURE />}
          />
          <Route
            exact
            path="/Activate_HistoryALGOTRADING"
            element={<Activate_HistoryALGOTRADING />}
          />
            <Route
            exact
            path="/Activate_HistoryADVTRADING"
            element={<Activate_HistoryADVTRADING />}
          />
           <Route
            exact
            path="/FranchiseeBusiness"
            element={<Statedistfranchiseebusiness />}
          />
           <Route
            exact
            path="/Distfranchiseebusiness"
            element={<Distfranchiseebusiness />}
          />
          
          <Route
            exact
            path="/Activate_HistoryFOREX"
            element={<Activate_HistoryFOREX />}
          />
          <Route exact path="/DashboardSelect" element={<DashboardSelect />} />
          <Route exact path="/DashboardBOT" element={<DashboardBOT />} />
          <Route exact path="/DashboardFIX" element={<DashboardFIX />} />
          <Route exact path="/HelpDesk" element={<HelpDesk />} />
          <Route exact path="/Notification" element={<Notification />} />

          <Route exact path="/ROIIncomefix" element={<ROIIncomefix />} />
          <Route exact path="/MatchingIncomeFIX" element={<MatchingIncomeFIX />} />
          <Route exact path="/RewardInomeFIX" element={<RewardInomeFIX />} />
          <Route exact path="/TradingIncomeFIX" element={<TradingIncomeFIX />} />
          <Route exact path="/TradingLevelIncomeFIX" element={<TradingLevelIncomeFIX />} />
          <Route exact path="/DirectIncomeFix" element={<DirectIncomeFixx />} />
          <Route exact path="/DirectIncomeFixTrading" element={<DirectIncomeFixTrading />} />
          <Route exact path="/ROIlevelIncomefix" element={<ROIlevelIncomefix />} />
          <Route exact path="/SilveGoldincomeFraFix" element={<SilveGoldincomeFraFix />} />

          <Route exact path="/DirectTeamBOT" element={<DirectTeamBOT />} />
          <Route exact path="/DownLineTeamBOT" element={<DownLineTeamBOT />} />
          <Route exact path="/LevelDetailsBOT" element={<LevelDetailsBOT />} />

          <Route exact path="/DirectTeamFIX" element={<DirectTeamFIX />} />
          <Route exact path="/DownLineTeamFIX" element={<DownLineTeamFIX />} />
          <Route exact path="/LevelDetailsFIX" element={<LevelDetailsFIX />} />

          <Route exact path="/DirectIncomeBot" element={<DirectIncomeBot />} />
          <Route
            exact
            path="/ROIlevelIncomeBot"
            element={<ROIlevelIncomeBot />}
          />
          <Route exact path="/ROIIncomeBot" element={<ROIIncomeBot />} />
          <Route
            exact
            path="/MatchingIncomeBot"
            element={<MatchingIncomeBot />}
          />
          <Route
            exact
            path="/MatchingLevelIncomeBot"
            element={<MatchingLevelIncomeBot />}
          />
          <Route exact path="/RewardInomeBot" element={<RewardInomeBot />} />
          <Route exact path="/ClubIncomeBot" element={<ClubIncomeBot />} />
          <Route
            exact
            path="/ClubRoyaltyIncomeBot"
            element={<ClubRoyaltyIncomeBot />}
          />
          <Route
            exact
            path="/FranchiseInomeBot"
            element={<FranchiseInomeBot />}
          />

          <Route exact path="/MatchingTreeBot" element={<MatchingTreeBOT />} />
          <Route exact path="/MatchingTreeFIX" element={<MatchingTreeFIX />} />

          <Route exact path="/WithdrawalBOT" element={<WithdrawalBOT />} />
          <Route exact path="/WithdrawalFIX" element={<WithdrawalFIX />} />
          <Route
            exact
            path="/WithdrawalHistoryFIX"
            element={<WithdrawalHistoryFIX />}
          />
          <Route
            exact
            path="/WithdrawalHistoryBOT"
            element={<WithdrawalHistoryBOT />}
          />
          <Route
            exact
            path="/CashbackIncomeBot"
            element={<CashbackIncomeBot />}
          />
          <Route
            exact
            path="/CashBackIncomeFix"
            element={<CashBackIncomeFix />}
          />
          <Route exact path="/HelpDeskBoat" element={<HelpDeskBoat />} />

          <Route exact path="/ActivateSECUREContract" element={<ActivateSECUREContract />} />
          <Route exact path="/ActivateADVTRADINGContract" element={<ActivateADVTRADINGContract />} />
          <Route exact path="/ActivateALGOTRADINGContract" element={<ActivateALGOTRADINGContract />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
